/*
 * @Description: 工具类函数
 * @Date: 2019-09-26 15:04:55
 * @LastEditTime: 2019-10-26 14:37:51
 */
import storejs from 'storejs'
import moment from 'moment'

let lang = storejs.get('lang');
let isCn = lang === 'zh-CN' || lang === 'zh-HK';

/**
 * 函数防抖
 * @param {Function} fn 执行的函数
 * @param {Number} delay 防抖时间，毫秒值
 */
let timer = null;
function debounce(fn, delay) {

    return function (name, value) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(name, value)
        }, delay);
    }
}

export const regEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
const regEn = /^[a-zA-Z]*$/;
/**
 * 表单校验
 * @param {String} value 值
 * @param {String} type 类型，如邮箱(email)
 */
function validate(value, type) {
    //非空
    if (value.trim().length === 0) {
        return false
    }
    // //只能输入英文
    // if (!regEn.test(value) && type === 'text') {
    //     return false;
    // }
    //校验邮箱地址
    if (type === 'email' && !regEmail.test(value)) {
        return false
    }

    return true;
}

/**
 * 校验对象是否为空对象{}
 * @param {Object} obj 待校验对象 
 */
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

/**
 * 获取汇率转换后的金额
 * @param {Number} price 原始金额
 * @param {Number} rate 汇率
 * @param {Number} percentStr 百分比
 */
function getAmount(price, rate, percentStr = 0) {
    let percent = percentStr / 100;
    // let result = Math.ceil(price * rate * 100) / 100;
    let result = ((price * percent + parseFloat(price)) * rate).toFixed(2);
    return price ? result : '';
}

/**
 * 格式化时间
 * @param {String} date 待格式化的时间值
 * @param {Boolean} isSeconds 是否为秒数，默认为否
 * @param {Boolean} hasWeek 时候包含星期，默认包含
 */
function formatDate(date, isSeconds = false, hasWeek = true) {

    //格式
    let formatStr = isCn ? 'YYYY-MM-DD' : 'DD MMM YYYY';
    if (hasWeek) {
        formatStr = isCn ? 'YYYY-MM-DD, ddd' : 'ddd, DD MMM YYYY';
    }

    return moment(isSeconds ? date * 1000 : date).format(formatStr)
}

/**
 * 格式化时间（机票时间格式）
 * @param {String} date 待格式化的时间值
 * @param {Boolean} isSeconds 是否为秒数，默认为否
 */
function formatDate4Flight(date, isSeconds) {

    //格式
    let formatStr = isCn ? 'YYYY-MM-DD HH:mm' : 'HH:mm DD MMM,YYYY';

    return moment(isSeconds ? date * 1000 : date).format(formatStr)
}

/**
 * 将秒数转化为 hh:mm的格式
 * @param {Number | String} secondTime 秒数
 */
function calcTime(secondTime) {
    let hour = Math.floor(secondTime / 3600);
    let offsetSecond = secondTime - hour * 3600;
    let minute = Math.floor(offsetSecond / 60);
    let hourStr = isCn ? '小时' : 'h';
    let minuteStr = isCn ? '分钟' : 'm';

    return `${hour < 10 ? "0" + hour : hour}${hourStr}${
        minute < 10 ? "0" + minute : minute
        }${minuteStr}`;
}

/**
 * 序列化酒店旅客参数
 * @param {*} data 
 */
function parseRoomData(data) {
    let roomData = {
        Adults: data.Adults,
        Children: 0,
        Cots: 0,
        Age: ''
    }
    let personGroup = [];
    for (let { Age } of data.Age) {
        if (Age < 2) {
            roomData.Cots++;
        } else {
            roomData.Children++;
            if (roomData.Age) {
                roomData.Age += `,${Age}`
            } else {
                roomData.Age = Age;
            }
        }
    }
    for (let i = 0; i < data.room; i++) {
        personGroup.push(roomData);
    }

    return personGroup;
}

/**
 * 返回序列化后的房间人数结构用于请求酒店列表
 * @param {*} data 旅客房间人数结构
 */
function parseRoomData2GetList(data) {
    let roomData = {
        Adults: data.Adults,
        Children: 0,
        Cots: 0,
        Age: ''
    }
    for (let { Age } of data.Age) {
        if (Age < 2) {
            roomData.Cots++;
        } else {
            roomData.Children++;
            if (roomData.Age) {
                roomData.Age += `,${Age}`
            } else {
                roomData.Age = Age;
            }
        }
    }
    return [roomData];
}

/**
 * 只限基本对象（不包含原型及函数等）深度拷贝
 * @param {*} data 
 */
function deepClone(data) {
    return JSON.parse(JSON.stringify(data))
}

/**
 * 解析url参数
 * @returns {Map} url参数构成的对象
 */
function decodeURLParams() {
    let url = location.href;
    let queryStr = url.split('?')[1];
    if (!queryStr) {
        return {}
    }
    let queryArr = queryStr.split('&');
    let result = {}
    queryArr.forEach(item => {
        let params = item.split('=');
        result[params[0]] = params[1];
    })
    return result;
}

/**
 * 生成随机数
 * @param {Number} digit 随机数的位数，默认5位
 */
function generateRandom(digit = 5) {
    let num = Math.pow(10, digit * 1 + 1);
    let random = Math.random();
    return Math.ceil(random * num);
}

/**
 * 获取两个坐标点之间的距离，返回km
 * @param {Number} lat1 纬度1
 * @param {Number} lng1 经度1
 * @param {Number} lat2 纬度2
 * @param {Number} lng2 经度2
 */
function getDistance(lat1, lng1, lat2, lng2) {
    var radLat1 = lat1 * Math.PI / 180.0;
    var radLat2 = lat2 * Math.PI / 180.0;
    var a = radLat1 - radLat2;
    var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;// EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000;
    return s;
}

/**
 * 跳转至新页面
 * @param {String} path 路由路径，传空则回首页
 * @param {String} type 链接类型，replace则替换当前页面
 */
function linkTo(path = '', type) {
    if (!path) {
        //为空则替换为首页
        location.replace(location.origin)
        return
    }
    if (type === 'replace') {
        location.replace(process.env.VUE_APP_PC + path)
    } else {
        window.open(process.env.VUE_APP_PC + path, '_blank');
    }
}

export {
    debounce,
    validate,
    isEmpty,
    getAmount,
    parseRoomData,
    parseRoomData2GetList,
    deepClone,
    decodeURLParams,
    generateRandom,
    getDistance,
    linkTo,
    formatDate,
    formatDate4Flight,
    calcTime
}


// WEBPACK FOOTER //
// ./src/lib/utils.js